import { useEffect, useState } from 'react';

/** A QR code as inline SVG, generated on this device. */
export function QrCode({
  text,
  size = 220,
  label,
}: {
  text: string;
  size?: number;
  label: string;
}) {
  const [svg, setSvg] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    void import('uqr').then(({ renderSVG }) => {
      if (alive)
        setSvg(renderSVG(text, { border: 2, whiteColor: '#ffffff', blackColor: '#0f1626' }));
    });
    return () => {
      alive = false;
    };
  }, [text]);
  return (
    <div
      role="img"
      aria-label={label}
      style={{
        width: size,
        height: size,
        borderRadius: 16,
        overflow: 'hidden',
        background: '#fff',
      }}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: SVG generated locally from our own text
      dangerouslySetInnerHTML={svg ? { __html: svg } : undefined}
    />
  );
}
